<template>
  <m-dialog ref="dlg" @save="save" :title="grup && grup.id ? 'Ubah Grup' : 'Tambah Grup'">
    <v-row row wrap justify="center" align="center">
      <v-col cols="12" sm="12" md="10" lg="8" xl="8">
        <v-form autocomplete="false" @submit.prevent data-vv-scope="form" lazy-validation>
          <v-card flat class="pa-5 mb-5">
            <v-row class="mx-2 pt-3">
              <v-col cols="12" class="px-5">
                <m-alert show :title="alert.grup.form.judul" :info="alert.grup.form.deskripsi" closable></m-alert>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row wrap class="mx-2">
                <v-col cols="12" class="my-0">
                  <v-text-field
                    outlined
                    dense
                    autocomplete="false"
                    name="Nama"
                    placeholder="Isikan Nama"
                    label="Nama Grup"
                    v-model="grup.nama"
                    persistent-hint
                    data-vv-name="nama"
                    data-vv-as="Nama"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.nama')"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import { ALERT_INFO } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {},

  data() {
    return {
      grup: {},
      defGrup: {
        nama: ""
      },
      alert: ALERT_INFO
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.grup = obj ? obj : this.defGrup;
      let x = this.$refs.dlg.open();
      this.$validator.reset();
      return x;
    },
    // eslint-disable-next-line
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("grup/form", {
              instansi_id: this.instansi_id,
              diklat_id: this.diklat_id,
              obj: this.grup
            })
            .then(res => {
              this.$refs.dlg.resolve();
              return res;
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
